module.exports = __webpack_public_path__ + "static/media/Artwork.05741447.svg";


//////////////////
// WEBPACK FOOTER
// ./src/artist-ui/components/Image/Artwork.svg
// module id = 189
// module chunks = 0